<template>
    <el-dialog
      :center="true"
      title=""
      :visible.sync="mdialogVisible"
      width="390px"
      :before-close="handleClose"
      class="custom"
    >
    <div class="custom-dialog">
        <div style="width: 100%;height: 40px;"><div style="float: right; margin: 10px; font-size: 24px;"><i class="el-icon-close" @click="handleClose"></i></div></div>
      <div v-if="message<0">
         <div style="font-size: 24px;color: #fc4e03;padding-top: 115px;font-weight: 700;">{{ $t('borrow.Bo62') }}</div>
         <div style="font-size: 24px;color: #fc4e03;margin: 12px 0px;font-weight: 700; ">{{ message }}  USDT</div>
         <div style=" font-size: 14px;margin: 15px 0px;color: #666666;font-weight: 600;letter-spacing: 2px;">{{ $t('borrow.Bo63') }}</div>
         </div>
      <div v-else>
        <div style="font-size: 20px;color: #fc4e03;padding-top: 115px;font-weight: 700;">{{ $t('borrow.Bo64') }}</div>
        <div style="font-size: 20px;color: #fc4e03;margin: 12px 0px; font-weight: 700;">+{{ message }}  USDT</div>
        <div style="font-size: 14px;color: #fc4e03;margin: 15px 0px;font-weight: 600;letter-spacing: 2px;">{{ $t('borrow.Bo65') }}</div>
      </div>
      <div style="text-align: center;margin-top: 30px;">
        <el-button v-if="message>0" type="danger" class="buttons"  style="background: #fc4e03" @click="handleConfirm">{{ $t('borrow.Bo66') }}</el-button>
        <el-button v-else type="success" class="buttons"    @click="handleConfirm">{{ $t('borrow.Bo66') }}</el-button>
    </div>
    </div>
    </el-dialog>
  </template>
  
  <script>
  export default {
    name: 'ModalComponent',
    props: {
      message: {
        type: Number,
        default: ''
      }
    },
    data() {
      return {
        mdialogVisible: false
      }
    },
    methods: {
      handleClose() {
        this.mdialogVisible = false
      },
      handleConfirm() {
        // 在这里处理确定按钮的逻辑
        this.$emit('confirm')
        this.mdialogVisible = false
      }
    }
  }
  </script>
  
  <style scoped>
  .buttons{
    font-size: 24px;
    padding: 12px 40px;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
  .custom-dialog {
    background-image: url('../../assets/images/mologo.jpg')!important;
    background-size: cover!important;
    border-radius: 15px;
    text-align: center;
    height: 380px;
  }
  
  .custom /deep/ .el-dialog__header {
    display: none !important;
    }
    .custom /deep/ .el-dialog__body {
    padding: 0!important;
   }
   .custom /deep/  .el-dialog{
    border-radius: 10px;
   }

  </style>


// WEBPACK FOOTER //
// src/components/modals/index.vue